module.exports = __webpack_public_path__ + "static/media/galleryImg3.475bb02f.jpg";